import { InfoItemProps } from "@/components/organisms";
import { defaultDateFormat } from "@/core/date";
import { defaultCurrencyFormat } from "@/core/number";
import i18n from "@/i18n";
import { InvoiceDetails } from "@/shared/domain/invoices";

import { getInvoiceStatus } from "../../utils/invoiceStatusMap";

export const invoiceDescriptionSchema = (invoice: InvoiceDetails, language: string): InfoItemProps[] => {
    const status = getInvoiceStatus(invoice.paymentDetails.paymentStatus.id);
    return [
        {
            key: "reference",
            label: i18n.t("Common.Reference"),
            value: invoice.paymentDetails.reference,
        },
        {
            key: "amount",
            label: i18n.t("Common.Amount"),
            value: defaultCurrencyFormat(invoice.paymentDetails.amount, language, false), // invoice of 0€ exist
            hideIfZero: false,
        },
        {
            key: "beneficiary",
            label: i18n.t("Invoice.Details.Beneficiary"),
            value: invoice.paymentDetails.beneficiaryAccount,
        },
        {
            key: "structuredCommunication",
            label: i18n.t("Invoice.Details.StructuredCommunication"),
            value: invoice.paymentDetails.structurePaymentReference,
        },
        {
            key: "status",
            label: i18n.t("Common.Status"),
            value: invoice.paymentDetails.paymentStatus.name,
            color: status.hexColor,
        },
    ];
};

export const invoiceContractSchema = (invoice: InvoiceDetails): InfoItemProps[] => [
    {
        key: "contract",
        label: i18n.t("Common.Contract"),
        value: invoice.contractDetails.contractBranch.name,
    },
    {
        key: "ref",
        label: i18n.t("Common.Reference"),
        value: invoice.contractDetails.contractReference,
    },
    {
        key: "company",
        label: i18n.t("Invoice.Details.Company"),
        value: invoice.contractDetails.company,
    },
    {
        key: "validFrom",
        label: i18n.t("Invoice.Details.ValidFrom"),
        value: defaultDateFormat(invoice.contractDetails?.validFrom),
    },
    {
        key: "validUntil",
        label: i18n.t("Invoice.Details.ValidUntil"),
        value: defaultDateFormat(invoice.contractDetails?.validUntil),
    },
];
